/** Converte célula do Excel para string, preservando o que for possível como texto. */
export function celulaExcelComoTexto(v: unknown): string {
  if (v == null || v === '') return '';
  if (typeof v === 'string') return v.replace(/\u00A0/g, ' ').trim();
  if (typeof v === 'number' && Number.isFinite(v)) return String(v);
  return String(v).replace(/\u00A0/g, ' ').trim();
}

export type LinhaPreviewImportNumeroProcesso = {
  indicePlanilha: number;
  numeroProcesso: string;
  valido: boolean;
  erros: string[];
};

/** Monta itens com id/data para qualquer lista que use só número de processo. */
export function montarItensNumeroProcessoImportados(linhas: LinhaPreviewImportNumeroProcesso[]): Array<{
  id: string;
  numeroProcesso: string;
  dataAdicao: Date;
}> {
  const agora = new Date();
  return linhas
    .filter((l) => l.valido)
    .map((l, i) => ({
      id: `import-${Date.now()}-${i}-${Math.random().toString(36).slice(2, 9)}`,
      numeroProcesso: l.numeroProcesso.trim(),
      dataAdicao: agora,
    }));
}
